<div class="overflow-x-hidden bg-white font-inter text-slate-950">
  <app-home-hero-section [previewScale]="appPreviewScale()" />
  <app-home-enterprise-section />
  <app-home-bridge-section />
  <app-home-device-section />
  <app-home-ai-insights-section />
  <!-- <app-home-ai-cards-section /> -->
<!--  <app-home-ai-showcase-section />-->
  <app-home-features-section />
  <app-home-integrations-section />
  <app-home-case-study-section />
  <app-home-cta-section />
</div>
